/* eslint-disable @typescript-eslint/naming-convention */
export const Ok = 200;
/** Invalid arguments passed. */
export const BadRequest = 400;
/** Authorization errors. */
export const Unauthorized = 401;
/** Access control violation. */
export const Forbidden = 403;
/** Item was not found. */
export const NotFound = 404;
/** Concurrency errors. */
export const Conflict = 409;
/** Unprocessable entity */
export const UnprocessableEntity = 422;
/** Failure to achieve consensus. */
export const Consensus = 499;
/** Size limit exceeded. */
export const PayloadTooLarge = 413;
/** The expectation could not be met */
export const ExpectationFailed = 417;
/** Operation not allowed. */
export const NotAllowed = 418;
/** Throttling error. */
export const TooManyRequests = 429;
/** Exceptions. */
export const UnhandledException = 500;
/** Not implemented errors. */
export const NotImplemented = 501;
/** Data integrity violation. */
export const DataCorruption = 510;
//# sourceMappingURL=statusCode.js.map